<template>
    <section class="bg-grey-3">
        <div class="container">
            <div class="text-title">About Us</div>
            <div class="row">
                <div class="col-xs-12 col-sm-9 col-md-7">
                    <p>
                        Avenir develops software tools for the HVAC and Plumbing industry, including <router-link to="product/loopcad">LoopCAD<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span></router-link> for the design of radiant heating and snow melt systems,
                        <router-link to="product/heatcad">HeatCAD<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span></router-link> for heating and cooling load calculations, and <router-link to="product/plumbingcad">PlumbingCAD<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span></router-link> for PEX-based plumbing takeoffs.
                        Our programs are easy to use, quick to learn, and have a strong focus on technical accuracy.
                        We are committed to providing timely support to our customers, ensuring they can complete their design work quickly and accurately.
                    </p>

                    <p>
                        We also develop <router-link to="product/custom">custom software</router-link> programs for application design and product selection,
                        specializing in tools for technical products that typically require application design and sizing calculations as an integral part of the selection and specification process.
                        Our development team includes Mechanical, Chemical and Software Engineers, with experience in a variety of industries.
                        This unique combination means that we already understand your products and applications, saving you valuable time and resources.
                    </p>

                    <p>
                        Since 1993 we have been providing state-of-the-art software solutions to the HVAC and Plumbing industry.
                        <router-link to="contact">Contact us</router-link> to find out how our software can assist with your technical marketing and sales efforts.
                    </p>

                    <div class="text-weight-medium q-mt-lg">Brad McCrea, P.Eng.</div>
                    <div class="text-weight-medium">President</div>
                </div>
                <div class="col-xs-0 col-sm-0 col-md-5 text-center">
                    <img :src="require('@/assets/img/content/About-Nature.jpg')" class="rounded-borders" style="width: 95%;" />
                </div>
            </div>
        </div>
    </section>
</template>
<script>

    export default {
        name: 'about',
    }
</script>
